import React from 'react';
import PropTypes from 'prop-types';

import Divider from 'elements/Divider/Divider';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './LandingFooter.css';

const LandingFooter = (props) => (
  <footer className={styles.slp}>
    <div className={styles.container}>
      <div className={styles.firstLevel}>
        <div className={styles.linksSection}>
          {props.renderMainLinks(styles, 'slp')}
        </div>
        {props.renderSectionLinks(styles)}
        <div className={styles.actionSection}>
          <LinkFreeStanding
            size={'xl'}
            icon={{
              direction: 'right',
              name: 'back-to-top',
              type: '30'
            }}
            onClick={props.toTopHandler}
          >
          {props.iconText}
          </LinkFreeStanding>
          <ul className={styles.socials}>
            {props.renderSocialLinks(styles)}
          </ul>
        </div>
      </div>
      <Divider />
      <div className={styles.secondLevel}>
        <ul className={styles.websiteLinksList}>
          {props.renderSiteLinks(styles)}
        </ul>
        <div className={styles.websiteInformation}>
          <p className={'small'}>
            {props.copyright}
          </p>
        </div>
      </div>
    </div>
  </footer>
);

LandingFooter.propTypes = {
  renderMainLinks: PropTypes.func,
  iconText: PropTypes.string,
  copyright: PropTypes.string,
  renderSectionLinks: PropTypes.func,
  renderSocialLinks: PropTypes.func,
  renderSiteLinks: PropTypes.func,
  toTopHandler: PropTypes.func
};

LandingFooter.defaultProps = {
  copyright: `\u00A9 ${(new Date()).getFullYear()} Airtel India. All Rights Reserved.`,
};

LandingFooter.displayName = 'LandingFooter';

export default LandingFooter;



// WEBPACK FOOTER //
// ./src/uis/components/Footer/LandingFooter/LandingFooter.js